export default __webpack_public_path__ + "e7f3dd99295e9a4c86d2132875c2db8d.svg";